import styled from 'styled-components';

import BaseButton from 'components/Buttons';
import { COLOR } from 'styles/styledComponents/color.model';

export const Button = styled(BaseButton)`
  span {
    color: ${COLOR.BATTERY_CELLS};
    font-weight: 600;
  }
`;
